import React from 'react';
import { inputStyles } from '../styles/sharedStyles';

const Input = ({
  label,
  type = 'text',
  value,
  onChange,
  placeholder = '',
  error = '',
  disabled = false,
  required = false,
  name,
  style = {},
  ...props
}) => {
  const [isFocused, setIsFocused] = React.useState(false);

  const inputStyle = {
    ...inputStyles.base,
    ...(isFocused && !error ? inputStyles.focus : {}),
    ...(error ? inputStyles.error : {}),
    ...(isFocused && error ? inputStyles.errorFocus : {}),
    ...style,
  };

  return (
    <div style={inputStyles.formGroup}>
      {label && (
        <label style={inputStyles.label}>
          {label}
          {required && <span style={{ color: '#dc3545', marginLeft: '4px' }}>*</span>}
        </label>
      )}
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        name={name}
        required={required}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        style={inputStyle}
        {...props}
      />
      {error && <div style={inputStyles.errorText}>{error}</div>}
    </div>
  );
};

export default Input;
